    
    
    import { NgModule } from '@angular/core';
    import { Routes, RouterModule } from '@angular/router';
    import { LoginRouteGuard, NotLoginRouteGuard } from './route-guard';

    const routes: Routes = [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'home',
        redirectTo: 'login',
        pathMatch: 'full'
        //loadChildren: './home/home.module#HomePageModule',
        // canActivate: [LoginRouteGuard]
      },

      {
        path: 'automotive/insurance',
        loadChildren: './insurance-list/insurance-list.module#InsuranceListPageModule',
        canActivate: [LoginRouteGuard]
      },

      {
        path: 'automotive/insurance/:id',
        loadChildren: './insurance-detail/insurance-detail.module#InsuranceDetailPageModule',
        canActivate: [LoginRouteGuard]
      },

      {
        path: 'login/:cmd',
        loadChildren: './login/login.module#LoginPageModule',
        //canActivate: [NotLoginRouteGuard]
      },
      {
        path: 'login',
        loadChildren: './login/login.module#LoginPageModule',
        //canActivate: [NotLoginRouteGuard]
      },
      {
        path: 'preview/:id',
        loadChildren: './preview/preview.module#PreviewPageModule',
        canActivate: [LoginRouteGuard]
      },

      { path: 'preview', loadChildren: './preview/preview.module#PreviewPageModule' },
      { path: 'solera', loadChildren: './solera/solera.module#SoleraPageModule' },
      { path: 'test', loadChildren: './test/test.module#TestPageModule' },
      { path: 'uploader', loadChildren: './uploader/uploader.module#UploaderPageModule' },
      { path: 'storage', loadChildren: './storage/storage.module#StoragePageModule' },
  { path: 'checkin/:id', loadChildren: './checkin/checkin.module#CheckinPageModule' },
  { path: 'checkout/:id', loadChildren: './checkout/checkout.module#CheckoutPageModule' },
  { path: 'checkinpb/:id', loadChildren: './checkinpb/checkinpb.module#CheckinpbPageModule' },



    ];

    @NgModule({
      imports: [RouterModule.forRoot(routes)],
      exports: [RouterModule]
    })
    export class AppRoutingModule { }
